// While the account's inbox has unread items the badge stays on, so the
// visibility reset below must not strip it when the tab comes back.
let keepBadge = false;
// Bump when the icon art changes; the PNGs are served with a 1-year max-age,
// so without this a returning tab keeps showing the previous mark. The plain
// favicons need it just as much as the badged ones -- swapping the badge off
// must not land back on a stale cached icon. Keep in step with the ?v= on the
// favicon links in app/views/layouts/vueapp.html.erb.
const ICON_VERSION = 4;

const swapFavicons = badged => {
  document.querySelectorAll('.favicon').forEach(favicon => {
    const size = favicon.sizes[[0]];
    favicon.href = badged
      ? `/favicon-badge-${size}.png?v=${ICON_VERSION}`
      : `/favicon-${size}.png?v=${ICON_VERSION}`;
  });
};

export const showBadgeOnFavicon = () => swapFavicons(true);

export const setInboxFaviconBadge = hasUnread => {
  keepBadge = hasUnread;
  swapFavicons(hasUnread);
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && !keepBadge) {
      swapFavicons(false);
    }
  });
};
